<template>
  <transition-group tag="div" name="list">
      <component
      v-for="(item,index) in galleryContent"
      :is="item.acf_fc_layout"
      :data="item"
      :key="index"
      :position="index"/>
  </transition-group>
</template>

<script>
import axios from 'axios';
import Router from 'vue-router'

import store from '../store'

import Logo from './Logo'
import GalleryItem from './GalleryItem'
import AdItem from './AdItem'


export default {
    name: 'home',
    components: {
        Logo,
        GalleryItem,
        AdItem
    },
    data () {
        return {
            wpData: null,
            galleryContent: [],
            test: this.$store
        }
    },
    beforeCreate() {
        axios.get('https://admin.ad.arbor.design/index.php/wp-json/wp/v2/posts?slug=home-page')
        .then( (res) => {
            // take the gallery content response and set it to global state
            this.$store.dispatch("updateGallery", res.data[0].acf.gallery);

            // set wpData to initial acf content
            this.wpData = res.data[0].acf

            // set gallery content specifically to the acf gallery array
            // this.galleryContent = res.data[0].acf.gallery;
            res.data[0].acf.gallery.forEach( (item,index) => {
                setTimeout(() => {
                    this.galleryContent.push({...item, pos: index})
                },150*index)
            })
        })
    },
    watch: {
    $route (to, from) {
            axios.get('https://admin.ad.arbor.design/index.php/wp-json/wp/v2/posts?slug=home-page')
        .then( (res) => {
            this.$store.dispatch("updateGallery", res.data[0].acf.gallery);
            this.wpData = res.data[0].acf
            res.data[0].acf.gallery.forEach( (item,index) => {
                setTimeout(() => {
                    this.galleryContent.push(item)
                },200*index)
            })
        })
    }},
    methods: {
        triggerDL() {
            _fetch()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>


* {
  box-sizing: border-box;
  z-index: 1;
}

.modal {
  position: absolute;
  width: 100%;
  max-width: 700px;
  background: white;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
}

.modal-header {
  width: 100%;
  height: 300px;
  background: url("https://images.unsplash.com/photo-1515075507420-d451cea9d688?ixlib=rb-0.3.5&q=85&fm=jpg&crop=entropy&cs=srgb&ixid=eyJhcHBfaWQiOjE0NTg5fQ&s=83ffcff384ee5b78973eb8680baa6489");
  background-position: center;
  background-size: 100%;
  -webkit-transform: translateX();
          transform: translateX();
}

.modal-content {
  padding: 20px;
}

.overlay {
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
}

.pv1 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.pv2 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.pv3 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.pv4 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.mv1 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.mv2 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.mv3 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.mv4 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.pt1 {
  padding-top: 1rem;
}

.pt2 {
  padding-top: 1.5rem;
}

.pt3 {
  padding-top: 2rem;
}

.mt1 {
  margin-top: 1rem;
}

.mt2 {
  margin-top: 1.5rem;
}

.mt3 {
  margin-top: 2rem;
}

.pb1 {
  padding-bottom: 1rem;
}

.pb2 {
  padding-bottom: 1.5rem;
}

.pb3 {
  padding-bottom: 2rem;
}

.mb1 {
  margin-bottom: 1rem;
}

.mb2 {
  margin-bottom: 1.5rem;
}

.mb3 {
  margin-bottom: 2rem;
}

.hidden {
  display: none;
}

.regular {
  font-weight: 400;
}

.medium {
  font-weight: 600;
}

.heavy {
  font-weight: 700;
}

.link-reset {
  text-decoration: none;
}




</style>



// WEBPACK FOOTER //
// src/components/Home.vue